import { render } from "./AppButton.vue?vue&type=template&id=b49876c6&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=b49876c6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b49876c6"]])

export default __exports__